<template>
  <div class="pg-table-input">
    <span>{{ pre }}</span>
    <input :value="value" readonly :style="{width:width}" :class="inputClass"/>
    <span>{{ suf }}</span>
  </div>
</template>

<script>
export default {
  name: "pg-table-input",
  props: {
    pre: {
      type: String,
      default: ''
    },
    inputClass: [String],
    width: [String, Number],
    suf: String,
    value: [String, Number]
  },
}
</script>

<style scoped lang="scss">
.pg-table-input {
  line-height: 28px;
  display: inline-block;

  input {
    text-align: center;
    width: 50px;
    font-size: 14px;
    border: 0px none;
    outline: none;
    border-bottom: 1px solid #333;
  }
}
</style>